/**
 * Update current page URL while keeping the global seller account query param.
 */
export function navigateListPageUrl(accountId, { set = {}, remove = ['page'] } = {}) {
	const url = new URL(window.location.href);
	remove.forEach((key) => url.searchParams.delete(key));
	Object.entries(set).forEach(([key, value]) => {
		if (value === null || value === undefined || value === '') {
			url.searchParams.delete(key);
		} else {
			url.searchParams.set(key, value);
		}
	});
	if (accountId) {
		url.searchParams.set('account', accountId);
	}
	window.location.href = url.toString();
}
